<template>
  <div class="modal is-active is-unselectable">
    <div class="modal-background" v-if="background" />
    <slot @hide="$emit('hide')" />
    <div class="modal-close" @click="$emit('hide')" v-if="cross" />
  </div>
</template>

<script>
export default {
  name: "modal",

  props: {
    background: Boolean,
    cross: Boolean
  }
};
</script>

<style></style>
